<ca-modal-container modalTitle="{{ title }}" (dismiss)="dismiss()" data-uit="add-tags-dialog">
    <form [formGroup]="formGroup" (ngSubmit)="submit()" novalidate>
        <div class="mb-5">
            <div class="mb-3">{{ selectedFiles }}</div>
            <zui-pill-content *ngFor="let tag of tags" class="pill">
                <zui-truncate-with-tooltip tooltip-trigger="hover,focus">
                    {{ tag }}
                </zui-truncate-with-tooltip>
                <zui-interactive-icon emphasis="subtle" slot="iconClose" (click)="removeTag(tag)"
                    ><zui-icon-symbols-close size="s8"></zui-icon-symbols-close
                ></zui-interactive-icon>
            </zui-pill-content>
            <div class="d-flex flex-column-reverse position-relative">
                <input
                    id="tag-input"
                    type="text"
                    class="form-control position-relative"
                    formControlName="value"
                    required
                    data-uit="add-tags-input"
                    [placeholder]="placeholder"
                    (input)="onInputChange()"
                    (focus)="handleInputFocus()"
                />
                <label for="tag-input">{{ inputLabel }}</label>
                <div class="d-flex confirm-tags position-absolute" *ngIf="showIcons">
                    <button
                        data-uit="create-tag-btn"
                        type="button"
                        (click)="addTag()"
                        class="confirm d-flex align-items-center btn ca-btn-icon me-1 confirm-MED-upload-modal"
                        [ngbTooltip]="'UPLOAD_MED_FILES_DIALOG.BUTTONS.CONFIRM' | translate"
                        #t="ngbTooltip"
                    >
                        <ca-icon name="checkmark" size="s"></ca-icon>
                    </button>
                    <button
                        data-uit="cancel-tag-btn"
                        type="button"
                        class="decline d-flex align-items-center btn ca-btn-icon cancel-MED-upload-modal"
                        (click)="onResetInput()"
                        [ngbTooltip]="'UPLOAD_MED_FILES_DIALOG.BUTTONS.CANCEL' | translate"
                        #t="ngbTooltip"
                        placement="top"
                    >
                        <ca-icon name="cross" size="s"></ca-icon>
                    </button>
                </div>
            </div>
        </div>
        <div class="mt-4 d-flex">
            <button type="button" caAutoFocus class="btn btn-secondary w-50 me-2" data-uit="add-tags-cancel-button" (click)="dismiss()">
                {{ cancelText }}
            </button>
            <button
                type="submit"
                caAutoFocus
                class="btn btn-primary w-50"
                [disabled]="!enableSubmitButton()"
                (click)="submit()"
                data-uit="add-tags-confirm-button"
            >
                {{ confirmText }}
            </button>
        </div>
    </form>
</ca-modal-container>
